var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.addedClasses.row }, [
    _c(
      "div",
      { staticClass: "msGridColumn1" },
      [
        _c("supplier-checkbox", {
          attrs: { state: _vm.supplier.bidState },
          on: {
            click: function ($event) {
              return _vm.handleSupplierCheckboxClicked(_vm.supplier)
            },
          },
        }),
      ],
      1
    ),
    _c("div", { staticClass: "msGridColumn3", class: _vm.$style.property }, [
      _c("div", { class: _vm.addedClasses.name }, [
        _vm.supplier.lastYear
          ? _c(
              "i",
              { staticClass: "material-icons", class: _vm.addedClasses.icon },
              [_vm._v("star")]
            )
          : _vm._e(),
        _c("span", { staticClass: "vAlignMiddle" }, [
          _vm._v(_vm._s(_vm.supplier.name)),
        ]),
        _vm.supplier.lastYear
          ? _c(
              "div",
              {
                staticClass: "rbTooltip simple",
                attrs: { tooltip: "placement:top-start" },
              },
              [_vm._v(" Was in Last Years Programme ")]
            )
          : _vm._e(),
      ]),
      _c("div", { class: _vm.$style.address }, [
        _vm._v(_vm._s(_vm.supplier.location.address.address1)),
      ]),
    ]),
    _c("div", { staticClass: "msGridColumn5", class: _vm.$style.cell }, [
      _vm.hasCity
        ? _c("span", { class: _vm.inBadgeCity }, [
            _vm._v(_vm._s(_vm.supplier.location.address.city)),
          ])
        : _vm._e(),
    ]),
    _c("div", { staticClass: "msGridColumn7", class: _vm.$style.cell }, [
      _vm.hasState
        ? _c("span", { class: _vm.inBadgeState }, [
            _vm._v(
              _vm._s(
                _vm.supplier.location.address.state ||
                  _vm.supplier.location.address.region
              )
            ),
          ])
        : _vm._e(),
    ]),
    _c("div", { staticClass: "msGridColumn9", class: _vm.$style.cell }, [
      _vm.hasCountry
        ? _c("span", { class: _vm.inBadgeCountry }, [
            _vm._v(_vm._s(_vm.supplier.location.address.country)),
          ])
        : _vm._e(),
    ]),
    _c("div", { staticClass: "msGridColumn11", class: _vm.$style.cell }, [
      _vm.hasDistance
        ? _c("span", { class: _vm.inBadgeDistance }, [
            _vm._v(_vm._s(_vm.formattedDistance)),
          ])
        : _vm._e(),
    ]),
    _c("div", { staticClass: "msGridColumn13", class: _vm.$style.cell }, [
      _vm.hasChain
        ? _c("span", { class: _vm.inBadgeChain }, [
            _vm._v(_vm._s(_vm.supplier.chain.masterChain.name)),
          ])
        : _vm._e(),
    ]),
    _c("div", { staticClass: "msGridColumn15", class: _vm.$style.cell }, [
      _vm.hasBrand
        ? _c("span", { class: _vm.inBadgeBrand }, [
            _vm._v(_vm._s(_vm.supplier.chain.name)),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }